module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table class="table-bordered">\r\n    <thead>\r\n        <td></td>\r\n        <td></td>\r\n        <td>\r\n            '+
((__t=(lang.VIEW))==null?'':_.escape(__t))+
'\r\n        </td>\r\n        <td>\r\n            '+
((__t=(lang.EDIT))==null?'':_.escape(__t))+
'\r\n        </td>\r\n\r\n        <td>\r\n            '+
((__t=(lang.BAJA))==null?'':_.escape(__t))+
'\r\n        </td>\r\n    </thead>\r\n    ';

    for(var p in permissions){
        var perm = permissions[p];
        print('<tr id="' + p + '"  data-itemarea="' + perm.area + '"  class="epigraph">');
        print('<td>' + lang[perm.area] + '</td>');
        print('<td></td>');
        print('<td><input type="checkbox"   class="view"/></td>');
        print('<td><input type="checkbox"   class="edit"/></td>');
 
        print('<td><input type="checkbox"   class="bajafichas"/></td>');
        print('</tr>');
        for (var c in perm.children){
            var subPerm = perm.children[c];

            var values = {};
            switch(subPerm.value){
                case "0":
                    values = {
                            view: '',
                            edit: '',
                            delete: ''
                        }
                    break;
                case "1":
                    values = {
                            view: 'checked',
                            edit: '',
                            delete: ''
                        }
                    break;
                case "2":
                    values = {
                            view: 'checked',
                            edit: 'checked',
                            delete: ''
                        }
                    break;
                case "3":
                default:
                    values = {
                        view: '',
                        edit: '',
                        delete: '', 
                    }
                    break;
            }

            

            var checkbajaFicha = '';
            if(subPerm.can_bajaficha == 1){
               checkbajaFicha = 'checked';
            }
 

            print('<tr id="' + subPerm.id + '" data-parent="' + subPerm.parent_id + '"  data-item="' + subPerm.area + '" class="subepigraph">');
            print('<td></td>');
            print('<td>' + lang[subPerm.area] + '</td>');
            print('<td><input type="checkbox"   class="view" ' + values.view + '/></td>');
            print('<td><input type="checkbox"   class="edit" ' + values.edit + '/></td>');
 
            print('<td><input type="checkbox"   class="bajafichas" ' + checkbajaFicha + '/></td>');
            print('</tr>');
        }
    }
    
__p+='\r\n</table>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/permissions/permissionsList.ejs
// module id = 438
// module chunks = 0